export default function () {
  const widgetName = 'mainFeatureSEOWidget';
  const widgetOpts = mainFeatureSEOWidgetOpts;

  function modifyParagraph(data) {
    const text = data.items[0].Description;
    const paragraphs = text.split('\n');
    let paragraph = '';
    
    paragraphs.forEach((p) => {
      paragraph += `<p>${p}</p>`;
    });

    $(`#${widgetName} .card-widget-description`).empty().append(paragraph);
  }

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function(data) {
      modifyParagraph(data);
      $(`#${widgetName}`).find('.buttonwrap a').addClass('button');
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: true,
      text: 'MORE INFO'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: false
  });

}